import * as z from 'zod';

import { schemaUtils } from 'src/components/hook-form/schema-utils';

import { PORTAL_PASSWORD_MIN_LENGTH, PORTAL_PASSWORD_MIN_LENGTH_HINT } from './constants';

const normalizedPortalEmailSchema = z
  .string()
  .transform((value) => value.trim().toLowerCase())
  .pipe(
    schemaUtils
      .email({
        error: {
          required: 'E-mailadres is verplicht.',
          invalid: 'Voer een geldig e-mailadres in.',
        },
      })
      .max(320, { error: 'E-mailadres mag maximaal 320 tekens bevatten.' })
  );

export const portalLoginSchema = z.object({
  email: normalizedPortalEmailSchema,
  password: z
    .string()
    .min(1, { error: 'Wachtwoord is verplicht.' })
    .max(200, { error: 'Wachtwoord mag maximaal 200 tekens bevatten.' })
    .min(PORTAL_PASSWORD_MIN_LENGTH, { error: PORTAL_PASSWORD_MIN_LENGTH_HINT }),
});

export type PortalLoginSchemaType = z.infer<typeof portalLoginSchema>;

export const portalForgotPasswordRequestSchema = z.object({
  email: normalizedPortalEmailSchema,
});

const portalPasswordFieldSchema = z
  .string()
  .min(1, { error: 'Wachtwoord is verplicht.' })
  .max(200, { error: 'Wachtwoord mag maximaal 200 tekens bevatten.' })
  .min(PORTAL_PASSWORD_MIN_LENGTH, { error: PORTAL_PASSWORD_MIN_LENGTH_HINT });

const portalPasswordConfirmationSchema = z
  .object({
    password: portalPasswordFieldSchema,
    confirmPassword: z
      .string()
      .min(1, { error: 'Bevestig je wachtwoord.' })
      .min(PORTAL_PASSWORD_MIN_LENGTH, { error: PORTAL_PASSWORD_MIN_LENGTH_HINT }),
  })
  .refine((value) => value.password === value.confirmPassword, {
    error: 'De wachtwoorden komen niet overeen.',
    path: ['confirmPassword'],
  });

export const portalCompletePasswordResetSchema = portalPasswordConfirmationSchema;

export const portalSetInitialPasswordSchema = portalPasswordConfirmationSchema;

export type PortalForgotPasswordRequestSchemaType = z.infer<
  typeof portalForgotPasswordRequestSchema
>;
export type PortalCompletePasswordResetSchemaType = z.infer<
  typeof portalCompletePasswordResetSchema
>;
export type PortalSetInitialPasswordSchemaType = z.infer<typeof portalSetInitialPasswordSchema>;
